module.exports = __webpack_public_path__ + "static/media/june_2025_1.9b23c33f.webp";